import { mix } from 'polished';
import styled, { css } from 'styled-components';

export type TVariant = 'purple' | 'warning' | 'error';

const VARIANT_STYLES: Record<TVariant, any> = {
  purple: css`
    background-color: ${props =>
      mix(
        0.7,
        props.theme.palette.neutral[50],
        props.theme.palette.secondary.main,
      )};

    svg {
      color: ${props => props.theme.palette.secondary.main};
    }

    .information__title {
      color: ${props => props.theme.palette.secondary.main};
    }

    .information__message {
      color: ${props => props.theme.palette.secondary.main};
    }
  `,
  warning: css`
    background-color: ${props =>
      mix(
        0.8,
        props.theme.palette.neutral[50],
        props.theme.palette.warning.main,
      )};

    svg {
      color: ${props => props.theme.palette.warning.dark};
    }

    .information__title {
      color: ${props => props.theme.palette.warning.dark};
    }

    .information__message {
      color: ${props => props.theme.palette.warning.dark};
    }
  `,
  error: css`
    background-color: ${props =>
      mix(
        0.8,
        props.theme.palette.neutral[50],
        props.theme.palette.error.main,
      )};
    svg {
      color: ${props => props.theme.palette.error.dark};
    }
    .information__title,
    .information__message {
      color: ${props => props.theme.palette.error.dark};
    }
  `,
};

export const Container = styled.section<{ variant: TVariant }>`
  display: flex;
  align-items: center;
  column-gap: 1.5rem;

  padding: 1.5rem;
  border-radius: 1.5rem;

  ${props => VARIANT_STYLES[props.variant]};

  svg {
    font-size: 2.5rem;
  }

  .information {
    flex: 1;
    display: flex;
    flex-direction: column;
    row-gap: 0.25rem;
  }

  .information__title {
    font-size: ${props => props.theme.typography.sizes.body1};
  }

  .information__message {
    font-size: ${props => props.theme.typography.sizes.caption};
  }
`;
